module.exports = __webpack_public_path__ + "static/mapaBg-273619b184600e90170ccf70c1932fec.jpg";